import { z } from "zod";

/** A completed profile has a nonblank, normalized display name. */
export const profileSchema = z.object({
  name: z.string().trim().min(1, "Name is required"),
});
